export const actionTypes = {
  setAttemptingWord: "setAttemptingWord"
};

export function setAttemptingWord(attempting: string | undefined) {
  return {
    type: actionTypes.setAttemptingWord,
    payload: attempting
  };
}
